import cc from 'store/util/createReduxConstant';

export const UPDATE_NOTICE_PERIOD = cc('RENEWALS_UPDATE_NOTICE_PERIOD');
